import { createV3Queries } from "@query/utils/createV3Queries";
import { cardsApi } from "@api";

export const queriesCards = createV3Queries("cardsApi", cardsApi);
